<section class="flex flex-col gap-8">
  <p class="text-center text-base">
    We power apps with millions of users worldwide
    <!-- We deliver updates to millions of users worldwide -->
  </p>
  <div class="grid grid-cols-3 justify-between gap-12 md:grid-cols-6">
    @for (icon of icons(); track icon.src) {
      <div class="flex flex-col items-center justify-center gap-2">
        @defer {
          <img
            [alt]="icon.alt"
            [class]="
              'h-12 w-12 rounded-xl object-cover shadow-md grayscale md:h-16 md:w-16' +
              (icon.invertColors ? ' invert' : '')
            "
            [src]="icon.src"
          />
        } @placeholder {
          <div
            class="h-12 w-12 animate-pulse rounded-xl bg-gray-200 md:h-16 md:w-16"
          ></div>
        }
        <div class="flex flex-col items-center gap-0.5">
          <p class="text-center text-xs font-medium text-gray-900">
            {{ icon.label }}
          </p>
          <p class="text-center text-xs text-gray-500">
            {{ icon.downloadCount }} Downloads
          </p>
        </div>
      </div>
    }
  </div>
</section>
